// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"7":"anchor-navigation","160":"main-navigation","173":"footer-form","312":"testimonial","324":"image-gallery-logotypes","644":"product-item","779":"logo-grid","792":"create-root"}[chunkId] || chunkId) + ".js";
};